<template>
  <div :class="disabled ? 'opacity-50' : ''">
    <div class="relative flex items-start">
      <div class="flex h-5 items-center">
        <input
          :value="true"
          :name="name"
          type="checkbox"
          class="size-6 rounded text-primary focus:ring-primary"
          :class="[
            errorMessage
              ? 'border-error'
              : 'border-background-fg/30',
            disabled ? 'cursor-not-allowed' : '',
          ]"
          :checked="checked"
          :disabled="disabled"
          @change="handleChange"
        />
      </div>
      <label
        :for="name"
        class="ml-3 block text-sm font-medium text-background-fg/70"
      >
        {{ label }}
      </label>
    </div>

    <p class="mt-1 text-xs font-medium text-error">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

const props = defineProps<{
  label?: string
  name: string
  disabled?: boolean
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void
}>()

const { checked, handleChange, errorMessage } = useField(
  toRef(props, "name"),
  undefined,
  {
    type: "checkbox",
    checkedValue: true,
    uncheckedValue: false,
  }
)
</script>
